export const optionsSlider ={
  dotSize: 16,
  maxRange: 1000,
  minRange: 1,
  min: 0,
  max: 1000,
  width: "300px",
  height: 4,
  direction: "ltr",
  interval: 1,
  clickable: true,
  duration: 0.5,
  adsorb: false,
  lazy: false,
  tooltip: "focus",
  tooltipPlacement: "top",
  useKeyboard: false,
  enableCross: true,
  fixed: false,
}